// Polling hook for the sidebar 'My Queue' unread badge (D4).
// Fires on mount and every 60 s. Cheap server-side count (single COUNT(*)).

import { useEffect, useState, useCallback } from 'react';
import { orderApi } from '../api/services';

export function useMyQueueUnread(intervalMs = 60_000) {
  const [count, setCount] = useState(0);
  const [team, setTeam] = useState(null);

  const fetch = useCallback(async () => {
    try {
      const res = await orderApi.myQueueUnreadCount();
      setCount(res.data.unread_count || 0);
      setTeam(res.data.team || null);
    } catch {
      // silent — sidebar should never spam errors
    }
  }, []);

  useEffect(() => {
    fetch();
    const i = setInterval(fetch, intervalMs);
    return () => clearInterval(i);
  }, [fetch, intervalMs]);

  return { count, team, refresh: fetch };
}
